// Shopify's Liquid has no shuffle/random filter, and even a server-side
// "random" order could look static to repeat visitors under Shopify's
// page caching — so this reshuffles client-side on every page load
// instead, which also guarantees a fair, even distribution over time
// (not biased toward whichever caching happened to freeze in place).
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sponsor-bar[data-randomize="true"]').forEach((bar) => {
    const tracks = bar.querySelectorAll('.sponsor-bar__track');
    if (tracks.length === 0) return;

    // Shuffle the first (visible) track's logos in place (Fisher-Yates).
    const firstTrack = tracks[0];
    const items = Array.from(firstTrack.children);
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item) => firstTrack.appendChild(item));

    // The marquee relies on a second, identical copy of the track to
    // loop seamlessly — keep it in sync with the newly shuffled order
    // rather than shuffling it independently.
    for (let t = 1; t < tracks.length; t += 1) {
      tracks[t].innerHTML = firstTrack.innerHTML;
    }
  });
});
